import React, {Suspense} from "react";
import BackdropSpinner from "../../../shared/backdrop-spinner/BackdropSpinner";
import ErrorBoundary from "../../../shared/error-boundary/ErrorBoundary";
import {Helmet} from "react-helmet";
import {useLocation} from "react-router-dom";

interface Props {
    Component: React.FunctionComponent;
    Layout: React.ComponentType<any>;
    title?: string;
}

const RouteWrapper = ({ Component, Layout, title }: Props) => {
    const {pathname} = useLocation();
    const normalizedTitle = (title ?? "").trim();
    const normalizedPath = pathname.length > 1 && pathname.endsWith("/")
        ? pathname.slice(0, -1)
        : pathname;
    const documentTitle = normalizedTitle ? `${normalizedTitle} | Genie` : "Genie";
    const canonicalUrl = `https://genie.mk${normalizedPath}`;
    const noindexPrefixes = [
        "/auth",
        "/forgot-password",
        "/reset-password",
        "/email-confirmation",
        "/profile",
        "/admin-panel",
        "/client-panel",
        "/unsubscribe-newsletter",
    ];
    const isNoindex = noindexPrefixes.some((prefix) => (
        normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
    ));

    return (
        <>
            <Helmet>
                <title>{documentTitle}</title>
                <link rel="canonical" href={canonicalUrl}/>
                <meta property="og:url" content={canonicalUrl}/>
                <meta name="twitter:url" content={canonicalUrl}/>
                {isNoindex ? (
                    <meta name="robots" content="noindex, nofollow"/>
                ) : null}
            </Helmet>
            <Layout>
                <ErrorBoundary>
                    <Suspense fallback={<BackdropSpinner />}>
                        <Component />
                    </Suspense>
                </ErrorBoundary>
            </Layout>
        </>
    );
};

export default RouteWrapper;
